module.exports = __webpack_public_path__ + "img/close-icon.e5acd3c7.svg";